import React from 'react';

export const feesRouteConfig = [
  {
    routes: [
      {
        path: '/fees',
        component: React.lazy(() => import('./Fees')),
      },
    ],
  },
];
